const ENV_KEY = import.meta.env.VITE_ENV_KEY || '100';
const ENV_LABEL_ENABLED = import.meta.env.VITE_ENV_LABEL !== 'false';

const LABELS = {
  '100': 'DEV',
  '200': 'STAGING',
};

export default function EnvironmentLabel() {
  const label = LABELS[ENV_KEY];
  if (!label || !ENV_LABEL_ENABLED) return null;

  const color = ENV_KEY === '100'
    ? 'bg-yellow-500 text-yellow-950'
    : 'bg-orange-500 text-white';

  return (
    <div
      className={`fixed bottom-2 left-2 z-[9999] px-2 py-0.5 rounded text-[10px] font-bold uppercase tracking-wider opacity-80 pointer-events-none select-none ${color}`}
    >
      {label}
    </div>
  );
}
